import "./broadband_react.css";
import React from "react";
import { HashRouter as Router } from "react-router-dom";
import Subscriber from "./subscriber.class";
import { takeWhile } from "rxjs";
import { getErrorObj } from "./services/errors.service";
import { initializeCoverage } from "./services/coverage.service";
import { printConsole } from "./services/brand.service";
import { fetchEssentials, SourcesCount } from "./services/essentials.service";
import { loadWidget as loadUserWayWidget } from "./services/userway.service";
import { initFlow, goTo } from "./services/flow.service";
import { userInit } from "./services/user.service";
import { LoadFB } from "./services/fb.service";
import Storage from "./services/storage.service";
import { CoverageCheckMapID } from "./static/fields.data";
import Settings from "./services/settings.service";
import SummaryModal from "./components/summary/summary-modal";
import Header from "./components/header/header.component";
import Footer from "./components/footer/html.component";
import Routes from "./routes";
import Redirecter from "./redirecter";
import MainSpinner from "./components/spinners/main";
import BodyClasses from "./components/body-classes/body-classes.component";
import Error from "./components/error/html";
import Events from "./services/events.service";
import { createBrowserHistory } from 'history';
import ErrorMessages from "./static/errors.data";
import Chat from "./components/Chat/chat";
const history = createBrowserHistory({
	basename: "", 
	hashType: "hash",
});
export default class App extends Subscriber {
  state = {
    ready: false,
    show_routes: true,
    error: null,
  };

  componentDidMount() {
    printConsole();
    loadUserWayWidget();
    LoadFB();
    userInit();
    initFlow();

    if (window.location.href.indexOf("/installment-success") !== -1) {
      goTo("/installment-success");
    }
    if (window.location.href.indexOf("/installment-fail") !== -1) {
      goTo("/installment-fail");
    }

    Events.initTracking();
    Storage.set("use_vat", false);
    Storage.set("clicks", 0);
    Storage.set("map_ref_" + CoverageCheckMapID, React.createRef());
    let loading_text = "Loading..";
    if (window.location.href.indexOf("/installment-success") !== -1) {
      loading_text = 'Please keep this window open while we complete your order';
    }
    if (window.location.href.indexOf("/installment-fail") !== -1) {
      loading_text = "Oops, your payment didn't go through! Please try again";
    }
    Storage.setShared("loading_text", loading_text);
    Storage.set("ok_to_locate", true);
    
    this.subscriptions.push(
      Storage.get_obsrv("logging_out").subscribe((logging_out) => {
        this.setState({ show_routes: !logging_out });
      })
    );

    this.subscriptions.push(
      Storage.get_obsrv("error").subscribe((data) => {
        this.setState({
          error: data? getErrorObj(data): null,
        });
      })
    );

    fetchEssentials()
      .pipe(takeWhile((val) => val <= SourcesCount))
      .subscribe((data) => {
        if (data === SourcesCount) {
          initializeCoverage();
          Storage.setShared("ready", true)
          this.setState({ ready: true });
        }
      });
    	history.listen(() => {
        window.scrollTo(0, 0)
		  });
      Storage.get_obsrv("businessConfig").subscribe((data) => {
        if (data) {
          this.setState({
            business_loaded: true,
            maintenance_mode: data.maintenance_mode
          });
          if (Settings.convert_project_id && data["enable_convert_websignup"]) {
            //check if convert script loaded already:
            const convertLoaded = document.getElementById("convert-experiments");
            if (!convertLoaded){
              const script = document.createElement("script");
              script.src = `//cdn-4.convertexperiments.com/v1/js/${Settings.convert_project_id}.js`;
              script.id = "convert-experiments";
              script.async = true;
              const staticScript = document.createElement("script");
              staticScript.innerHTML = 'var _conv_page_type="home";';
              document.head.appendChild(staticScript);
              document.head.appendChild(script);
					}
          }
        } else {
          if (data === false) {
            this.setState({
              business_loaded: false,
            });
          }
        }
      });
			Storage.get_obsrv("error").subscribe((data) => {
        if (data) {
          let error_type = data["type"];
          if (Settings.debug_errors) console.log("error", error_type);
          // console.log('THE ERROR IS ========>>>>>>>>>>>>', data)
          let error_obj = ErrorMessages?.error_general;
          if (ErrorMessages?.[error_type]) {
            error_obj = ErrorMessages?.[error_type];
          }
          if (data["code"]) {
            error_obj["code"] = data["code"];
          }

          this.setState({
            error: error_obj,
          });
        } else {
          this.setState({
            error: null,
          });
        }
      })
  }

  render() {
    let router = "";
    let footer = "";

    if (this.state.ready) {
      if (this.state.show_routes) {
        router = (
          <Router history={history}>
            <Redirecter />
            <Routes />
          </Router>
        );
      }
      footer = <Footer />;
    }

    return (
      <div className={"agent " + navigator.userAgent.toLowerCase()}>
        <BodyClasses />
        <div id="vmo" onClick={()=>{
          Storage.set("clicks", Storage.get("clicks") + 1);
        }}>
          <div className={"vmo-wrapper vmo-onboarding vmo-onboarding-bb"}>
            <Header />
            <div className="vmo-bb-page">
              <MainSpinner />
              <Error error={this.state.error} />
              {router}
            </div>
          </div>
          {footer}
          <div className="floaters">
							{Settings.enable_sendbird && this.state.business_loaded ? (
								<div className="send-bird-wrapper">
									<div className="send-bird-container">
									<Chat/>
									</div>
								</div>
							) : (
								""
							)}
						</div>
        </div>
        <div ref={Storage.get("map_ref_" + CoverageCheckMapID)} />
        <SummaryModal />
      </div>
    );
  }
}
